var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoorKeyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#d6dce2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "door, key, room, hotel") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.66,12h-.91A12.85,12.85,0,0,1,40,14.5V15a1,1,0,0,1-2,0v-.14A12.73,12.73,0,0,0,27.08,2.1,12.49,12.49,0,0,0,13.85,10,10,10,0,0,0,10,29.13V41a1,1,0,0,0,.11.45l2,4a1,1,0,0,0,.73.54H13a1,1,0,0,0,.71-.29l4-4a1,1,0,0,0,0-1.42L16.41,39l1.3-1.29a1,1,0,0,0,0-1.42L16.41,35l1.3-1.29A1,1,0,0,0,18,33V29.13a9.92,9.92,0,0,0,2.95-2A12.25,12.25,0,0,0,25.5,28a12.56,12.56,0,0,0,4.5-.84v5.5A3.35,3.35,0,0,0,33.34,36h7.32A3.35,3.35,0,0,0,44,32.66V15.34A3.35,3.35,0,0,0,40.66,12ZM30,15.34V25a10.59,10.59,0,0,1-7.67.52A9.9,9.9,0,0,0,24,20a10,10,0,0,0-6.27-9.26A10.23,10.23,0,0,0,17,14.5V15h0a2.62,2.62,0,0,1,1,2c0,1.68-1.76,3-4,3s-4-1.32-4-3c0-1.43,1.27-2.58,3-2.9,0,.13,0,.26,0,.4v1.67c-.62.2-1,.55-1,.83s.78,1,2,1,2-.59,2-1-.38-.63-1-.83V14.81A10.69,10.69,0,0,1,23.93,4.12,10.48,10.48,0,0,1,35.67,12H33.34A3.35,3.35,0,0,0,30,15.34Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorKeyIcon);
export default __webpack_public_path__ + "static/media/door-key-icon.16ba4ea54c10b78d96f0da83e4ed69e8.svg";
export { ForwardRef as ReactComponent };